import * as actionTypes from "./types";

const initialState = {
  loading: false,
  success: false,
  error: null,
  listTicket: null,
  crudSuccess: false,
  crudError: null,
};

const listTicketReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LIST_TICKET_INITIATED: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.LIST_TICKET_SUCCESS: {
      return {
        ...state,
        loading: false,
        listTicket: action.payload,
        success: true,
        error: null,
      };
    }
    case actionTypes.LIST_TICKET_FAILED: {
      return {
        ...state,
        loading: false,
        listTicket: null,
        success: false,
        error: action.payload,
      };
    }

    // ** Update Ticket **
    case actionTypes.UPDATE_TICKET_INITIATED: {
      return {
        ...state,
        loading: true,
        crudSuccess: false,
      };
    }
    case actionTypes.UPDATE_TICKET_SUCCESS: {
      return {
        ...state,
        loading: false,
        crudSuccess: true,
        crudError: null,
      };
    }
    case actionTypes.UPDATE_TICKET_FAILED: {
      return {
        ...state,
        loading: false,
        crudSuccess: false,
        crudError: action.payload,
      };
    }

    // ** Delete Event
    case actionTypes.DELETE_TICKET_INITIATED: {
      return {
        ...state,
        loading: true,
        crudSuccess: false,
      };
    }
    case actionTypes.DELETE_TICKET_SUCCESS: {
      return {
        ...state,
        loading: false,
        crudSuccess: true,
        crudError: null,
      };
    }
    case actionTypes.DELETE_TICKET_FAILED: {
      return {
        ...state,
        loading: false,
        crudSuccess: false,
        crudError: action.payload,
      };
    }

    // ** reset errors
    case actionTypes.RESET_ERRORS: {
      return {
        ...state,
        crudError: action.payload,
      };
    }
    
    default: {
      return {
        ...state,
      };
    }
  }
};

export default listTicketReducer;
